import Clarity from '@microsoft/clarity';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Routes from './main/routes';

import './index.css';
import * as serviceWorker from './serviceWorker';
import { setupAxiosInterceptors } from "./main/requestAgent";
import store from './state/store';

import consts from './main/consts';

// require('dotenv').config();
setupAxiosInterceptors(store);

if (consts.ENABLE_CLARITY) {
  Clarity.init("trqi5zajpe");
}

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
